import React, { FC } from 'react';
import { If, Then, Else } from 'react-if';

import { Box } from '@nerdwallet/currency/components/Box';
import { Text } from '@nerdwallet/currency/components/Text';
import { Stack } from '@nerdwallet/currency/components/Stack';
import {
  FormInput,
  FormSelect,
  FormInputDate,
} from './form-builder/form-input';
import styles from './styles.module.scss';

interface Props {
  isCreditScoreActivated: boolean;
}

const PersonalInfoForm: FC<Props> = ({ isCreditScoreActivated }) => {
  return (
    <Stack spacing="3">
      <Text bold>Personal information</Text>

      <div className={styles.twoColumnGrid}>
        <div>
          <FormSelect
            block
            field="gender"
            label="Gender"
            options={[
              {
                value: '',
                label: 'Pick one',
                disabled: true,
              },
              {
                value: 'MALE',
                label: 'Male',
              },
              {
                value: 'FEMALE',
                label: 'Female',
              },
              {
                value: 'NONBINARY',
                label: 'Non-binary',
              },
            ]}
          />
        </div>

        <FormInputDate label="Birth date" field="birthdate" fullWidth />
      </div>

      <If condition={isCreditScoreActivated}>
        <Then>
          <FormInput
            fullWidth
            field="creditScore"
            label="Credit score"
            tooltip={
              <div className={styles.tooltip}>
                <Stack spacing="2">
                  <Text bold>When is my score updated?</Text>
                  <Text>
                    We pull your most updated score from TransUnion at least
                    once a week on the same day. Note that this day might change
                    if you get other alerts about your credit in the same week.
                  </Text>
                </Stack>
              </div>
            }
            disabled
            className={styles.creditScoreInput}
          />

          <Box marginTop="1">
            <Text size="small">
              This is pulled from your linked credit score.
            </Text>
          </Box>
        </Then>
        <Else>
          <FormSelect
            field="creditScore"
            label="Credit score"
            options={[
              {
                value: '',
                label: 'Pick one',
                disabled: true,
              },
              {
                value: 550,
                label: '300-599',
              },
              {
                value: 625,
                label: '600-649',
              },
              {
                value: 675,
                label: '650-699',
              },
              {
                value: 725,
                label: '700-749',
              },
              {
                value: 775,
                label: '750-799',
              },
              {
                value: 825,
                label: '800-850',
              },
            ]}
          />
        </Else>
      </If>
    </Stack>
  );
};

export default PersonalInfoForm;
